import { capitalizeFirstLetter } from "./capitalizeFirstLetter";

export const formatStatus = (status: string) => {
  switch (status) {
    case "pending_approval":
      return "Pending Approval";
    case "approved":
      return "Approved";
    case "rejected":
      return "Rejected";
    case "deleted":
      return "Deleted";
    case "passed_training":
      return "Passed Training";
    default:
      return capitalizeFirstLetter(status);
  }
};
